import { render } from "./DevCredit.vue?vue&type=template&id=3daf8f3f&scoped=true"
import script from "./DevCredit.vue?vue&type=script&lang=js"
export * from "./DevCredit.vue?vue&type=script&lang=js"

import "./DevCredit.vue?vue&type=style&index=0&id=3daf8f3f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3daf8f3f"]])

export default __exports__